// Query keys — centre de notifications & tâches (WKF-013).

const notificationsAll = ['notifications'] as const
const tasksAll = ['tasks'] as const

export const notificationsKeys = {
    notifications: {
        all: notificationsAll,
        list: (entityId: string, filters?: Record<string, unknown>) =>
            [...notificationsAll, 'list', entityId, filters] as const,
        // Vue calendrier (WKF-013 §7.2bis) : plage de dates + onglet.
        calendar: (entityId: string, range?: Record<string, unknown>) =>
            [...notificationsAll, 'calendar', entityId, range] as const,
        unreadCount: (entityId: string) =>
            [...notificationsAll, 'unread-count', entityId] as const,
        // Canal « Instantané » (onScreen) : file de toasts drainée par poll.
        onScreen: (entityId: string) =>
            [...notificationsAll, 'onscreen', entityId] as const,
        detail: (id: string) => [...notificationsAll, 'detail', id] as const,
        // NOTIF-002 — absences & délégation ; scope = 'me' ou un userId (admin).
        absences: (scope: string) => [...notificationsAll, 'absences', scope] as const,
    },
    tasks: {
        all: tasksAll,
        admin: (entityId: string, filters?: Record<string, unknown>) =>
            [...tasksAll, 'admin', entityId, filters] as const,
        adminIds: (entityId: string, filters?: Record<string, unknown>) =>
            [...tasksAll, 'admin-ids', entityId, filters] as const,
    },
}
